export default __webpack_public_path__ + "static/media/p2023-10.fd49a4ef.jpeg";